<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-9">
                    <br><br>
                    <h3 class="titulo">Flujo de Efectivo</h3>
                </div>
                <div class="col-lg-3">
                    <br><br>
                    <!-- <button class="btn btn-primary" (click)="openModal(agregarModal)">Agregar Ingreso</button><br><br> -->
                </div>
            </div>

            <div class="row">
                <p class="bold">Datos del mes:</p>
                <div class="col-lg-3">
                    <p class="center fondoNegro amarillo2">Dinero Disponible:<br>
                        <span class="bold">{{dineroEfectivo|currency}}</span>
                    </p>
                </div>

                <div class="col-lg-3">
                    <!-- <p class="center fondoNegro amarillo2">Dinero en efectivo:<br>
                        <span class="bold">{{dineroEfectivo|currency}}</span>
                    </p> -->
                </div>

                <div class="col-lg-3">
                    <!-- <p class="center fondoNegro amarillo2">Dinero en cuenta banco:<br>
                        <span class="bold">{{dineroCuentaBanco|currency}}</span>
                    </p> -->
                </div>
            </div>
            <br>
            <div class="row">
               <div class="col-lg-11">
                   <table class="table table-striped">
                       <thead>
                            <tr>
                                <td>Fecha</td>
                                <td>Concepto</td>
                                <td>Ingreso</td>
                                <td>Egreso</td>
                                <td>Total</td>
                            </tr>
                       </thead>
                       <tbody>
                           <tr *ngFor="let movimiento of movimientosNuevos">
                                <td>{{movimiento.fecha}}</td>
                                <td>{{movimiento.concepto}}</td>
                               <td>
                                   <div *ngIf="movimiento.tipo ==  0">
                                        -
                                   </div>

                                   <div *ngIf="movimiento.tipo ==  1">
                                        {{movimiento.monto | currency}}
                                    </div>
                               </td>
                               <td>
                                    <div *ngIf="movimiento.tipo ==  0">
                                        {{movimiento.monto | currency}}
                                    </div>

                                    <div *ngIf="movimiento.tipo ==  1">
                                        -
                                    </div>
                                </td>
                                <td>
                                    {{movimiento.totalFinal | currency}}
                                </td>
                           </tr>
                       </tbody>
                   </table>
               </div>
            </div>
        </div>
    </div>
</div>


<!-- <ng-template #agregarModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Registro</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Concepto</span><br>
        <select class="form-control" [(ngModel)]="formulario.concepto">
            <option value="">Seleccionar Concepto</option>
            <option value="Ingreso por terminal bancaria">Ingreso por terminal bancaria</option>
            <option value="Ingreso en efectivo">Ingreso en efectivo</option>
        </select><br>

        <span class="bold">Monto</span><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formulario.total"><br>

        <span class="bold">Origen:</span><br>
        <select class="form-control" [(ngModel)]="formulario.forma_pago">
            <option value="1">Efectivo</option>
            <option value="2">Cuenta Bancaria</option>
        </select><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarIngreso()">Agregar Ingreso</button>
    </div>
</ng-template> -->